"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeMenuScene = void 0;
const blocks_1 = require("../blocks");
const pixi_js_1 = require("pixi.js");
const i18next_1 = __importDefault(require("i18next"));
const Global_1 = require("../Global");
const DrawingBackground_1 = require("../blocks/DrawingBackground");
const SceneManager_1 = require("../managers/SceneManager");
const interfaces_1 = require("../../../shared/interfaces");
const rxjs_1 = require("rxjs");
const cog_svg_1 = __importDefault(require("../../assets/svg/cog.svg"));
const man_svg_1 = __importDefault(require("../../assets/svg/man.svg"));
const BattleSprite_1 = require("../objects/BattleSprite");
const MenuButton_1 = require("../blocks/MenuButton");
const settings_1 = require("../config/settings");
const IconButton_1 = require("../blocks/IconButton");
const SettingsPopup_1 = require("../popups/SettingsPopup");
const MenuScene_1 = require("./MenuScene");
const GuessSprite_1 = require("../objects/GuessSprite");
const levels_1 = require("../../../shared/levels");
const SpeedSprite_1 = require("../objects/SpeedSprite");
const AssetManager_1 = __importDefault(require("../managers/AssetManager"));
class HomeMenuScene extends MenuScene_1.MenuScene {
    constructor(app, sceneManager, gameManager) {
        super(app, sceneManager, gameManager);
        this.zIndex = SceneManager_1.Layer.Menu;
        // We are on mange page, leave rooms
        this.gameManager.leaveRoom();
        this.username = this.makeUsername();
        this.menu = this.makeMenu();
        this.tray = this.addChild(this.setupTray());
        // Change language
        this.subs.add(this.gameManager.langChange$.subscribe({
            next: () => {
                if (this.settingsPopup) {
                    this.makeSettingsPopup(true);
                }
            }
        }));
        this.subs.add(gameManager.playerManager.playerData$.subscribe((data) => {
            const field = this.username.getChildByName('username-field');
            const status = this.username.getChildByName('username-status');
            if ((data === null || data === void 0 ? void 0 : data.user) && data.user !== (field === null || field === void 0 ? void 0 : field.value)) {
                this.makeUserTextfield(this.size);
            }
            else if (status) {
                status.visible = false;
            }
        }));
        this.subs.add(gameManager.userChange$.pipe((0, rxjs_1.skip)(1)).subscribe((userValid) => {
            const status = this.username.getChildByName('username-status');
            const field = this.username.getChildByName('username-field');
            if (field) {
                if (status && userValid !== null && (field).editing) {
                    status.visible = true;
                    switch (userValid) {
                        case interfaces_1.UserValid.Available:
                            status.text = i18next_1.default.t('mainmenu.available');
                            status.style.fill = settings_1.Settings.availableColor;
                            break;
                        case interfaces_1.UserValid.Unavailable:
                            status.text = i18next_1.default.t('mainmenu.unavailable');
                            status.style.fill = settings_1.Settings.unavailableColor;
                            break;
                        case interfaces_1.UserValid.Inappropriate:
                            status.text = i18next_1.default.t('mainmenu.inappropriate');
                            status.style.fill = settings_1.Settings.unavailableColor;
                            break;
                        default:
                            status.visible = false;
                    }
                }
                else {
                    field.value = gameManager.playerManager.data.user;
                    status.visible = false;
                }
            }
        }));
    }
    get size() {
        return this.overSmallSize ? 145 : 130;
    }
    get space() {
        return this.overSmallSize ? 18 : 8;
    }
    setupTray() {
        const ss = this.overSmallSize ? 0.18 : 0.14;
        const ts = this.overSmallSize ? 26 : 20;
        if (this.tray) {
            const bc1 = (this.tray.getChildAt(0));
            const icon = (bc1).getChildAt(0);
            icon.sprite.scale.set((0, Global_1.px)(ss));
            icon.text.style.fontSize = (0, Global_1.fontSize)(ts);
            icon.layout();
            const bc2 = (this.tray.getChildAt(1));
            const other = (bc2).getChildAt(0);
            other.pivot.set((0, Global_1.px)(other.w / 2), (0, Global_1.px)(other.h / 2));
            other.w = this.size * 1.1;
            other.h = bc1.height / (0, Global_1.px)();
            other.padding = this.size / 3 / 5;
            other.radius = 2;
            other.font = ts;
            other.layout();
            bc1.x = bc2.x = 0;
            if (!(0, Global_1.isrtl)()) {
                bc1.x = (0, Global_1.px)(other.w / 2) + bc1.width / 2 + (0, Global_1.px)(this.space);
            }
            else {
                bc2.x = icon.width / 2 + bc2.width / 2 + (0, Global_1.px)(this.space);
            }
            this.tray.pivot.set(this.tray.width / 2 - ((0, Global_1.isrtl)() ? icon.width / 2 : (0, Global_1.px)(other.w / 2)), 0);
            return this.tray;
        }
        else {
            const container = new pixi_js_1.Container();
            const sprite = pixi_js_1.Sprite.from(cog_svg_1.default);
            sprite.scale.set((0, Global_1.px)(ss));
            const icon = new IconButton_1.IconButton(this.app, new pixi_js_1.Text(i18next_1.default.t('mainmenu.settings'), blocks_1.Block.textStyle()), sprite, 7);
            const button = icon.asButton(0.01);
            this.sigs.push(button.onPress.connect(() => {
                this.makeSettingsPopup();
                AssetManager_1.default.untickSound();
            }));
            container.addChild(button);
            // Other Button
            const otherButton = (new MenuButton_1.MenuButton(this.app, i18next_1.default.t('mainmenu.friends').toString(), settings_1.Settings.othersColor, (this.size * 1.1), this.size / 3.5, this.size / 3 / 5, 2, ts)).asButton(0.01);
            otherButton.name = 'others';
            this.sigs.push(otherButton.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
                AssetManager_1.default.tickSound();
                yield this.sceneManager.routeTo(SceneManager_1.Scenes.Others, otherButton);
            })));
            container.addChild(otherButton);
            return container;
        }
    }
    makeSettingsPopup(withreload = false) {
        var _a;
        const sprite = pixi_js_1.Sprite.from(cog_svg_1.default);
        sprite.scale.set((0, Global_1.px)(0.6));
        const wasthere = !this.settingsPopup;
        (_a = this.settingsPopup) === null || _a === void 0 ? void 0 : _a.destroy(true);
        this.settingsPopup = new SettingsPopup_1.SettingsPopup(this.app, this.gameManager, wasthere);
        this.settingsPopup.confirm = () => __awaiter(this, void 0, void 0, function* () {
            this.settingsPopup = null;
            // Reload the game after settings closed (items could have changed)
            if (withreload) {
                yield this.sceneManager.routeTo(SceneManager_1.Scenes.Home, null, true);
            }
        });
        this.addChild(this.settingsPopup);
        this.layout();
    }
    makeUsername() {
        const container = new pixi_js_1.Container();
        container.sortableChildren = true;
        // Text
        const txt = i18next_1.default.t('username');
        const text = new pixi_js_1.Text(txt.toString(), blocks_1.Block.textStyle(this.size / 5.5));
        text.name = 'username-title';
        text.zIndex = 1;
        container.addChild(text);
        // Name Status
        const style = blocks_1.Block.textStyle(this.size / 5.5);
        style.align = 'center';
        const status = new pixi_js_1.Text(null, style);
        status.anchor.set(0.5, 0);
        status.style.align = 'center';
        status.name = 'username-status';
        status.zIndex = 1;
        container.addChild(status);
        return this.addChild(container);
    }
    makeUserTextfield(size) {
        var _a, _b, _c;
        (_a = ((this.username.getChildByName('username-field')))) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = ((this.username.getChildByName('username-sprite')))) === null || _b === void 0 ? void 0 : _b.destroy();
        const text1 = (this.username.getChildByName('username-title'));
        const text2 = (this.username.getChildByName('username-status'));
        const data = this.gameManager.playerManager.data;
        const textfield = this.makeTextfield({
            placeholder: (!(data === null || data === void 0 ? void 0 : data.custom) && (data === null || data === void 0 ? void 0 : data.user) ? data.user : null),
            value: ((data === null || data === void 0 ? void 0 : data.custom) && (data === null || data === void 0 ? void 0 : data.user) ? data.user : null),
            fontSize: size / 5.5,
            width: 200,
            maxLength: 16,
            height: 36
        });
        textfield.name = 'username-field';
        textfield.y = (text1 === null || text1 === void 0 ? void 0 : text1.height) + (0, Global_1.px)(6);
        this.sigs.push(textfield.onChange.connect((val) => {
            if (!this.gameManager.checkUser(val)) {
                text2.visible = false;
            }
        }));
        this.sigs.push(textfield.onEnter.connect((val) => {
            if (!this.gameManager.changeUser(val)) {
                text2.visible = false;
            }
        }));
        textfield.zIndex = 0;
        this.username.addChild(textfield);
        // Center text
        if (text1) {
            text1.x = this.username.width / 2 - text1.width / 2 - (0, Global_1.px)(4);
        }
        if (text2) {
            text2.x = (0, Global_1.px)(100);
            text2.y = textfield.y + textfield.height + (0, Global_1.px)(6);
            text2.visible = false;
        }
        // Make badge
        const lvl = (_c = this.gameManager.playerManager.data) === null || _c === void 0 ? void 0 : _c.lvl;
        if (lvl && levels_1.levels[lvl - 1]) {
            const level = levels_1.levels[lvl - 1];
            const badge = pixi_js_1.Sprite.from(require('../../assets/levels/' + level.badge + '.svg').default);
            badge.zIndex = 2;
            badge.anchor.set(0.5);
            badge.scale.set((0, Global_1.px)(0.15));
            badge.name = 'username-sprite';
            const pad = (0, Global_1.isrtl)() ? (0, Global_1.px)(16) : textfield.width - (0, Global_1.px)(16);
            badge.position.set(textfield.x + pad, textfield.y - (0, Global_1.px)(14));
            this.username.addChild(badge);
        }
        this.layout();
    }
    makeMenu() {
        const size = this.size;
        const space = this.space;
        const container = new pixi_js_1.Container();
        container.name = 'buttons';
        // Battle Button
        container.addChild(this.makeBattleButton());
        // Guess Button
        container.addChild(this.makeGuessButton());
        // Levels Button
        this.levelsButton = (new MenuButton_1.MenuButton(this.app, i18next_1.default.t('mainmenu.levels').toString(), settings_1.Settings.levelsColor, (size * 2) + space, size / 3, size / 3 / 12, size > 140 ? 4 : 2, size / 3.625)).asButton(0.01);
        this.levelsButton.name = 'game' + interfaces_1.GameType.Levels;
        this.sigs.push(this.levelsButton.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
            AssetManager_1.default.tickSound();
            yield this.sceneManager.routeTo(SceneManager_1.Scenes.Levels, this.levelsButton);
        })));
        const levelSprite = pixi_js_1.Sprite.from(man_svg_1.default);
        levelSprite.name = 'levelSprite';
        levelSprite.anchor.set(0.5);
        this.levelsButton.addChild(levelSprite);
        container.addChild(this.levelsButton);
        // Speed Button
        this.speedButton = (new MenuButton_1.MenuButton(this.app, i18next_1.default.t('mainmenu.speed').toString(), settings_1.Settings.speedColor, (size * 2) + space, size / 3, size / 3 / 12, size > 140 ? 4 : 2, size / 3.625)).asButton(0.01);
        this.speedButton.name = 'game' + interfaces_1.GameType.Speed;
        this.sigs.push(this.speedButton.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
            AssetManager_1.default.tickSound();
            yield this.sceneManager.routeTo(SceneManager_1.Scenes.Speed, this.speedButton);
        })));
        const speedSprite = new SpeedSprite_1.SpeedSprite(this.app, 7);
        speedSprite.name = 'speedSprite';
        this.speedButton.addChild(speedSprite);
        this.sigs.push(this.speedButton.onHover.connect(() => {
            speedSprite.play();
        }));
        container.addChild(this.speedButton);
        return this.addChild(container);
    }
    makeGuessButton() {
        const mbutton = new MenuButton_1.MenuButton(this.app, i18next_1.default.t('mainmenu.guess').toString(), settings_1.Settings.guessColor, this.size, this.size, this.size / 12, this.size > 140 ? 4 : 2, this.size / 3.625);
        this.guessButton = mbutton.asButton(0.01);
        this.guessButton.name = 'game' + interfaces_1.GameType.Guess;
        // Guess Sprite
        const guessSprite = new GuessSprite_1.GuessSprite(this.app);
        guessSprite.name = 'guessSprite';
        guessSprite.play();
        mbutton.addChild(guessSprite);
        this.sigs.push(this.guessButton.onHover.connect(() => {
            guessSprite.play();
        }));
        this.sigs.push(this.guessButton.onOut.connect(() => {
            guessSprite.stop();
        }));
        this.sigs.push(this.guessButton.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
            AssetManager_1.default.tickSound();
            yield this.sceneManager.routeTo(SceneManager_1.Scenes.Guess, this.guessButton);
        })));
        return this.guessButton;
    }
    makeBackground() {
        // Simple way to have more drawings for more screen
        const max = 20;
        const min = 3;
        const total = Math.floor(max * this.app.screen.width / (0, Global_1.px)() / 1920);
        const clamp = Math.min(Math.max(min, total), max);
        const container = new DrawingBackground_1.DrawingBackground(this.app, clamp);
        container.speed = 0.008;
        const items = [settings_1.Settings.battleColor, settings_1.Settings.guessColor, settings_1.Settings.speedColor, settings_1.Settings.levelsColor];
        container.nextColor = () => {
            return items[Math.floor(Math.random() * items.length)];
        };
        return (this.addChild(container));
    }
    makeBattleButton() {
        const mbutton = new MenuButton_1.MenuButton(this.app, i18next_1.default.t('mainmenu.battle').toString(), settings_1.Settings.battleColor, this.size, this.size, this.size / 12, this.size > 140 ? 4 : 2, this.size / 3.625);
        this.battleButton = mbutton.asButton(0.01);
        this.battleButton.name = 'game' + interfaces_1.GameType.Battle;
        // Battle Sprites
        const battleSprite = new BattleSprite_1.BattleSprite(this.app);
        battleSprite.play();
        battleSprite.name = 'battleSprite';
        mbutton.addChild(battleSprite);
        // Add text rock to battlesprite animation stream
        const bbtext = mbutton.getChildByName('text');
        battleSprite.tm.to(bbtext, {
            yoyo: true,
            ease: 'none',
            keyframes: [
                { pixi: { rotation: 8 } },
                { pixi: { rotation: -8 } },
                { pixi: { rotation: 0 } }
            ],
            duration: 0.1
        }, 'shock');
        this.sigs.push(this.battleButton.onHover.connect(() => {
            if (battleSprite.tm && !battleSprite.tm.isActive()) {
                bbtext.rotation = 0;
            }
            battleSprite.play();
        }));
        this.sigs.push(this.battleButton.onOut.connect(() => {
            battleSprite.stop();
        }));
        this.sigs.push(this.battleButton.onPress.connect(() => __awaiter(this, void 0, void 0, function* () {
            AssetManager_1.default.tickSound();
            yield this.sceneManager.routeTo(SceneManager_1.Scenes.Battle, this.battleButton);
        })));
        return this.battleButton;
    }
    get triggersStop() {
        return true;
    }
    layout() {
        this.background.start();
        const battleButton = (this.battleButton.getChildAt(0));
        battleButton.w = battleButton.h = this.size;
        battleButton.padding = this.size / 12;
        battleButton.radius = this.size > 140 ? 4 : 2;
        battleButton.font = this.size / 3.625;
        battleButton.layout();
        const bs = battleButton.getChildByName('battleSprite');
        bs === null || bs === void 0 ? void 0 : bs.position.set((0, Global_1.px)(this.size / 2), 0);
        bs === null || bs === void 0 ? void 0 : bs.layout();
        const guessButton = (this.guessButton.getChildAt(0));
        guessButton.w = guessButton.h = this.size;
        guessButton.padding = this.size / 12;
        guessButton.radius = this.size > 140 ? 4 : 2;
        guessButton.font = this.size / 3.625;
        guessButton.layout();
        const gs = guessButton.getChildByName('guessSprite');
        gs === null || gs === void 0 ? void 0 : gs.position.set((0, Global_1.px)(this.size / 2 + 2), (0, Global_1.px)(45.5));
        gs === null || gs === void 0 ? void 0 : gs.layout();
        const levelsButton = (this.levelsButton.getChildAt(0));
        const speedButton = (this.speedButton.getChildAt(0));
        this.battleButton.pivot.set(battleButton.width / 2, battleButton.height / 2);
        this.guessButton.pivot.set(guessButton.width / 2, guessButton.height / 2);
        const buttonA = (0, Global_1.isrtl)() ? this.guessButton : this.battleButton;
        const buttonB = (0, Global_1.isrtl)() ? this.battleButton : this.guessButton;
        if (this.isLandscapeBox) {
            const lspace = this.space * 1.9;
            const mini = this.size / 2.5;
            const minipadding = mini / 5.5;
            levelsButton.w = (this.size * 1.6);
            levelsButton.h = mini;
            levelsButton.padding = minipadding;
            levelsButton.radius = this.size > 140 ? 4 : 2;
            levelsButton.font = this.size / 3.625;
            levelsButton.layout();
            speedButton.w = (this.size * 1.6);
            speedButton.h = mini;
            speedButton.padding = minipadding;
            speedButton.radius = this.size > 140 ? 4 : 2;
            speedButton.font = this.size / 3.625;
            speedButton.layout();
            this.levelsButton.pivot.set(levelsButton.width / 2, levelsButton.height / 2);
            this.speedButton.pivot.set(speedButton.width / 2, speedButton.height / 2);
            if ((0, Global_1.isrtl)()) {
                this.levelsButton.position.set(levelsButton.width / 2, levelsButton.width / 2);
                this.speedButton.position.set((0, Global_1.px)(speedButton.w / 2), (0, Global_1.px)(speedButton.h / 2));
                this.guessButton.position.set(this.levelsButton.x + (0, Global_1.px)(levelsButton.w / 2) + guessButton.width / 2 + (0, Global_1.px)(lspace), guessButton.width / 2);
                this.battleButton.position.set(this.guessButton.x + (0, Global_1.px)(guessButton.w / 2) + (0, Global_1.px)(lspace) + (0, Global_1.px)(battleButton.w / 2), (0, Global_1.px)(battleButton.h / 2));
            }
            else {
                this.battleButton.position.set(battleButton.width / 2, battleButton.height / 2);
                this.guessButton.position.set(this.battleButton.x + battleButton.width + (0, Global_1.px)(lspace), guessButton.height / 2);
                this.levelsButton.position.set(this.guessButton.x + (0, Global_1.px)(guessButton.w / 2) + levelsButton.width / 2 + (0, Global_1.px)(lspace), levelsButton.width / 2);
                this.speedButton.position.set(this.guessButton.x + (0, Global_1.px)(guessButton.w / 2) + (0, Global_1.px)(lspace) + (0, Global_1.px)(speedButton.w / 2), (0, Global_1.px)(speedButton.h / 2));
            }
            this.menu.position.set(this.center.x - this.menu.width / 2, this.center.y - (0, Global_1.px)(28));
            this.username.position.set(this.app.screen.width / 2 - (0, Global_1.px)(100), (0, Global_1.px)(58));
        }
        else {
            buttonA.position.set(buttonA.width / 2, buttonA.height / 2);
            buttonB.position.set((0, Global_1.px)(this.size + this.space) + buttonB.width / 2, buttonB.height / 2);
            levelsButton.w = (this.size * 2) + this.space;
            levelsButton.h = this.size / 3;
            levelsButton.padding = this.size / 3 / 10;
            levelsButton.radius = this.size > 140 ? 4 : 2;
            levelsButton.font = this.size / 3.625;
            levelsButton.layout();
            this.levelsButton.pivot.set(levelsButton.width / 2, levelsButton.height / 2);
            this.levelsButton.position.set((0, Global_1.px)(levelsButton.w / 2), (0, Global_1.px)(this.size + this.space + levelsButton.h / 2));
            speedButton.w = (this.size * 2) + this.space;
            speedButton.h = this.size / 3;
            speedButton.padding = this.size / 3 / 7;
            speedButton.radius = this.size > 140 ? 4 : 2;
            speedButton.font = this.size / 3.625;
            speedButton.layout();
            this.speedButton.pivot.set(speedButton.width / 2, speedButton.height / 2);
            this.speedButton.position.set((0, Global_1.px)(speedButton.w / 2), (0, Global_1.px)(this.size + this.size / 3 + this.space * 2 + speedButton.h / 2));
            this.menu.position.set(this.center.x - this.menu.width / 2, this.app.screen.height / 3 - (this.overSmallSize ? 0 : (0, Global_1.px)(15)));
            this.username.position.set(this.app.screen.width / 2 - (0, Global_1.px)(100), this.app.screen.height / 7 - (this.overSmallSize ? 0 : (0, Global_1.px)(10)));
        }
        // Resize sprites
        const speedSprite = (this.speedButton.getChildByName('speedSprite'));
        speedSprite.layout();
        speedSprite.scale.set(0.54 * ((0, Global_1.isrtl)() ? -1 : 1), 0.54);
        const pads = (0, Global_1.px)(this.overSmallSize ? 40 : 36);
        speedSprite.position.set((0, Global_1.isrtl)() ? ((0, Global_1.px)(speedButton.w) - pads) : pads, (0, Global_1.px)(this.size / 3 / 2 + (this.isLandscapeBox ? 4 : 1)));
        const levelSprite = (this.levelsButton.getChildByName('levelSprite'));
        levelSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.46 : 0.36));
        const padl = (0, Global_1.px)(this.overSmallSize ? 34 : 31);
        levelSprite.position.set((0, Global_1.isrtl)() ? ((0, Global_1.px)(levelsButton.w) - padl / 1.5) : padl, (0, Global_1.px)(this.size / 3 / 2 + (this.overSmallSize ? 3 : 5)));
        // I'm so tired of this menu, just call this twice
        this.setupTray();
        this.tray.position.set(this.center.x, this.menu.y + this.menu.height + (0, Global_1.px)(this.space) + (0, Global_1.px)(18));
        this.setupTray();
        super.layout();
    }
}
exports.HomeMenuScene = HomeMenuScene;
